import { render, staticRenderFns } from "./ExtAccount.vue?vue&type=template&id=37fbb1e4&scoped=true&"
import script from "./ExtAccount.vue?vue&type=script&lang=js&"
export * from "./ExtAccount.vue?vue&type=script&lang=js&"
import style0 from "./ExtAccount.vue?vue&type=style&index=0&id=37fbb1e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fbb1e4",
  null
  
)

export default component.exports